const TeamHyfye = () => {
    return (
    <section id="team">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-12 offset-lg-2">
            <div className="title_dark title_border text-center">
              <h4 className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">Our Team</h4>
              <p className="animation" data-animation="fadeInUp" data-animation-delay="0.1s">
                Meet the passionate team behind Hyfye — innovators, builders, and believers in creating a global economy of gratitude.
              </p>
            </div>
          </div>
        </div>
    
        <div className="row small_space">
    
          <div className="col-lg-3 col-md-6 col-sm-6 res_md_mb_30 res_sm_mb_20">
            <div className="team_box animation" data-animation="fadeInUp" data-animation-delay="0.1s">
              <div className="team_img gradient_box text-center">
                <img loading="lazy" src="https://pub-ba546ddaa1784315aecd8b5bd97af3a2.r2.dev/images/team/Derek.png" alt="Derek Castro" />
              </div>
              <div className="team_info text-center" id="DerekCastro">
                <h4>Derek Castro</h4>
                <h5>Head of Marketing</h5>
                <p className="small_text">Derek leads our global marketing efforts with a passion for creative storytelling and brand building.</p>
              </div>
            </div>
          </div>
    
          <div className="col-lg-3 col-md-6 col-sm-6 res_md_mb_30 res_sm_mb_20">
            <div className="team_box animation" data-animation="fadeInUp" data-animation-delay="0.1s">
              <div className="team_img gradient_box text-center">
                <img loading="lazy" src="https://pub-ba546ddaa1784315aecd8b5bd97af3a2.r2.dev/images/team/Jessica.png" alt="Jessica Bell" />
              </div>
              <div className="team_info text-center" id="JessicaBell">
                <h4>Jessica Bell</h4>
                <h5>Head of Sales</h5>
                <p className="small_text">Jessica drives our partnerships and investor relationships, bringing years of experience in blockchain sales leadership.</p>
              </div>
            </div>
          </div>
         <div className="col-lg-3 col-md-6 col-sm-6 res_md_mb_30 res_sm_mb_20">
            <div className="team_box animation" data-animation="fadeInUp" data-animation-delay="0.1s">
              <div className="team_img gradient_box text-center">
                <img loading="lazy" src="https://pub-ba546ddaa1784315aecd8b5bd97af3a2.r2.dev/images/team/Parul.png" alt="Parul Bansal" />
              </div>
              <div className="team_info text-center" id="ParulBansal">
                <h4>Parul Bansal</h4>
                <h5>Blockchain Infra Expert</h5>
                <p className="small_text">  He architects secure, scalable smart contract systems and ensures seamless blockchain integration across the platform.</p>
              </div>
            </div>
          </div>
           
          <div className="col-lg-3 col-md-6 col-sm-6 res_md_mb_30 res_sm_mb_20">
            <div className="team_box animation" data-animation="fadeInUp" data-animation-delay="0.1s">
              <div className="team_img gradient_box text-center">
                <img loading="lazy" src="https://pub-ba546ddaa1784315aecd8b5bd97af3a2.r2.dev/images/team/Martin.png" alt="Alvaro Martin" />
              </div>
              <div className="team_info text-center"  id="AlvaroMartin">
                <h4>Alvaro Martin</h4>
                <h5>Blockchain Developer</h5>
                <p className="small_text">Alvaro is a blockchain innovator focused on developing Hyfye’s decentralized infrastructure and smart contract systems.</p>
              </div>
            </div>
          </div>
    
          <div className="col-lg-3 col-md-6 col-sm-6">
            <div className="team_box animation" data-animation="fadeInUp" data-animation-delay="0.1s">
              <div className="team_img gradient_box text-center">
                <img loading="lazy" src="https://pub-ba546ddaa1784315aecd8b5bd97af3a2.r2.dev/images/team/Maria.png" alt="Maria Willium" />
              </div>
              <div className="team_info text-center"  id="MariaWillium">
                <h4>Maria Willium</h4>
                <h5>Community Manager</h5>
                <p className="small_text">Maria builds and supports our global Hyfye community — connecting people, answering questions, and spreading positivity.</p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 res_md_mb_30 res_sm_mb_20">
            <div className="team_box animation" data-animation="fadeInUp" data-animation-delay="0.1s">
              <div className="team_img gradient_box text-center">
                <img loading="lazy" src="https://pub-ba546ddaa1784315aecd8b5bd97af3a2.r2.dev/images/team/Ali.png" alt="Ali Awais" />
              </div>
              <div className="team_info text-center" id="AliAwais">
                <h4>Ali Awais</h4>
                <h5>Senior Graphic Designer</h5>
                <p className="small_text"> He crafts visually engaging designs, ensuring brand consistency and creating impactful graphics for web, print, and digital platforms.</p>
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 res_md_mb_30 res_sm_mb_20">
            <div className="team_box animation" data-animation="fadeInUp" data-animation-delay="0.1s">
              <div className="team_img gradient_box text-center">
                <img loading="lazy" src="https://pub-ba546ddaa1784315aecd8b5bd97af3a2.r2.dev/images/team/DavidChen.png" alt="David Chen" />
              </div>
              <div className="team_info text-center" id="DavidChen">
                <h4>David Chen</h4>
                <h5>Software Developer</h5>
                <p className="small_text">
                    A seasoned developer from California, David brings deep expertise from his time at crafting high-performance, scalable applications with a user-first approach.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    )}
    export default TeamHyfye;
    